import { render, staticRenderFns } from "./SplitShipmentAddressManager.vue?vue&type=template&id=657c569c&scoped=true"
import script from "./SplitShipmentAddressManager.vue?vue&type=script&lang=js"
export * from "./SplitShipmentAddressManager.vue?vue&type=script&lang=js"
import style0 from "./SplitShipmentAddressManager.vue?vue&type=style&index=0&id=657c569c&prod&scoped=true&lang=css"
import style1 from "./SplitShipmentAddressManager.vue?vue&type=style&index=1&id=657c569c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c569c",
  null
  
)

export default component.exports